module.exports = __webpack_public_path__ + "static/img/site-5.fc20b7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/site-5.png
// module id = qVFQ
// module chunks = 0